var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5H12.5C8.35786 5 5 8.35786 5 12.5V27.5C5 31.6421 8.35786 35 12.5 35H27.5C31.6421 35 35 31.6421 35 27.5V12.5C35 8.35786 31.6421 5 27.5 5Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9351 19.1199C26.1202 20.3683 25.907 21.6432 25.3257 22.7634C24.7445 23.8836 23.8248 24.792 22.6975 25.3594C21.5703 25.9268 20.2928 26.1243 19.0468 25.9238C17.8008 25.7233 16.6497 25.135 15.7574 24.2426C14.865 23.3503 14.2767 22.1992 14.0762 20.9532C13.8757 19.7072 14.0732 18.4297 14.6406 17.3025C15.208 16.1752 16.1164 15.2555 17.2366 14.6743C18.3568 14.093 19.6317 13.8798 20.8801 14.0649C22.1535 14.2537 23.3324 14.8471 24.2426 15.7574C25.1529 16.6676 25.7463 17.8465 25.9351 19.1199Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H28.0137",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.992b46f73cc21627282572ac218e237c.svg";
export { ForwardRef as ReactComponent };